var escape = require("../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@font-face {\n\tfont-family: Arial, Helvetica, sans-serif;\n\tsrc: url(" + escape(require("../components/mainLayout/fonts/ARIAL.TTF")) + ");\n  }\nbody {\n\tfont-family: Arial, Helvetica, sans-serif;\n\theight: 100%;\n\tmargin-top: -1em !important;\n}\n\n.card-customized {\n\tborder-width: 2px;\n    border-color: #6b1e29;\n}\n\n.image-preview {\n\twidth: 60%;\n}", ""]);

// exports
